<template>
  <div class="modal-content">
    <button type="button" class="close" @click="$emit('closeModal')">
      <span aria-hidden="true"><svg v-svg symbol="x" size="0 0 17 17"></svg></span>
    </button>
    <div class="domain-modal d-flex flex-column">
      <template v-if="isDataLoaded">
        <template v-if="zones.length == 0">
          <div class="domain-text mt-4 mb-3 text-center no-domain">
            {{ $t("domain.buy_domain_modal.no_domain_1") }}
          </div>
        </template>

        <template v-else>
          <h4 class="domain-title">
            <svg v-svg symbol="globe2" width="31px" height="29px"></svg>
            {{ $t("domain.buy_domain_modal.title") }}
          </h4>

          <ul class="tabs">
            <li v-for="(tab, index) in tabs" :key="index">
              <button @click.prevent="currentTab = tab" :class="{ active: currentTab === tab }">
                {{ $t(`domain.buy_domain_modal.${tab}`) }}
                <span v-if="tab === 'auto'" class="badge-new">NEW</span>
              </button>
            </li>
          </ul>

          <template v-if="currentTab === 'manual'">
            <div class="domain-type">
              <label for="domainType"> {{ $t("domain.buy_domain_modal.domain_type") }}</label>
              <custom-multiselect id="domainType" :list="domainTypeList" v-model="domainType" :allowEmpty="false">
                <template v-slot:block="props">
                  <span>
                    {{ $t("domain.buy_domain_modal.domain_for", { type: props.value }) }}
                  </span>
                </template>
                <template v-slot:list="props">
                  <span>
                    {{ $t("domain.buy_domain_modal.domain_for", { type: props.value }) }}
                  </span>
                </template>
              </custom-multiselect>
            </div>

            <div class="domain-type">
              <label for="domainZone"> {{ $t("domain.buy_domain_modal.domain_zone") }}</label>
              <custom-multiselect id="domainZone" :list="zones" v-model="currentDomain" :allowEmpty="false">
                <template v-slot:block="props">
                  <span> .{{ props.value.zone }} </span>
                </template>
                <template v-slot:list="props">
                  <span v-if="props.value.zone === 'ru'">
                    <span> .{{ props.value.zone }} </span><span class="green-text">- {{ $t("domain.buy_domain_modal.only_ru") }}</span>
                  </span>
                  <span v-else> .{{ props.value.zone }} </span>
                </template>
              </custom-multiselect>
            </div>

            <InfoBlock v-if="currentDomain.zone === 'ru'" :text="$t('domain.buy_domain_modal.domain_ru_info')" class="domain-ru-info mb-3"></InfoBlock>

            <div class="price-block">
              <svg v-svg symbol="dollar-circle" width="18px" height="18px"></svg>
              {{ $t("domain.buy_domain_modal.price") }} <span class="price">{{ currentDomain.price }} USD</span> <br />
              {{ $t("domain.buy_domain_modal.write_off") }}
            </div>

            <div class="domain-footer">
              <button class="btn _mob100 _bg-green" @click="buyDomain">
                {{ $t("domain.buy_domain_modal.buy") }}
              </button>
            </div>
          </template>

          <template v-if="currentTab === 'auto'">
            <div class="domain-type">
              <label for="domainZone"> {{ $t("domain.buy_domain_modal.domain_zone") }}</label>

              <custom-multiselect id="domainZone" :list="zones" v-model="currentAutoBuyDomains" :multiply="true" :disabled="isActive" :allowEmpty="false">
                <template v-slot:block="props">
                  <span> .{{ props.value.zone }} - {{ props.value.price }} $</span>
                </template>
                <template v-slot:list="props">
                  <span> .{{ props.value.zone }} </span>
                  <span class="green-text">- {{ props.value.price }} USD</span>
                </template>
              </custom-multiselect>
            </div>

            <div class="price-block mb-3">
              <svg v-svg symbol="dollar-circle" width="18px" height="18px"></svg>
              {{ $t("domain.buy_domain_modal.auto_info") }}
            </div>

            <div class="row">
              <div class="col-12 col-lg-6">
                <Counter class="pb-0" v-model="amountDomain" :invalid="!isValidAutoBuy" :disabled="isActive" :max="10" :min="1" :title="'domain.buy_domain_modal.domain_count'" :description="'domain.buy_domain_modal.domain_count_text'" />
              </div>

              <div class="col-12 col-lg-6">
                <label class="form-item__label info-popup">
                  {{ $t("domain.buy_domain_modal.interval_title") }}
                </label>
                <custom-multiselect class="multiselect-wrapper multiselect-w-100" :class="{ invalid: !isValidAutoBuy }" v-model="interval" :list="intervalList" :disabled="isActive" :allowEmpty="false">
                  <template v-slot:block="props">
                    <span>
                      {{ props.value.label }}
                    </span>
                  </template>
                  <template v-slot:list="props">
                    <span>
                      {{ props.value.label }}
                    </span>
                  </template>
                </custom-multiselect>
              </div>
            </div>

            <div v-if="!isValidAutoBuy" class="warning-block">
              <svg v-svg symbol="info" width="18px" height="18px"></svg>
              <span v-html="$t('domain.buy_domain_modal.warning_text')"></span>
            </div>

            <div class="domain-footer">
              <button v-if="!isActive" @click="setAutoBuyDomain(true)" class="btn _bg-green _mob100" :disabled="isLoading || !isValidAutoBuy">
                {{ $t("domain.buy_domain_modal.launch") }}
              </button>
              <button v-else @click="setAutoBuyDomain(false)" class="btn _mob100" :disabled="isLoading || !isValidAutoBuy">
                {{ $t("domain.buy_domain_modal.stop") }}
              </button>

              <div v-if="isActive" class="autobuy-active">{{ $t("domain.buy_domain_modal.autobuy_text") }}</div>
            </div>
          </template>
        </template>
      </template>

      <loader v-else />
    </div>

    <alert v-if="$alert.title" />
  </div>
</template>
<script>
import InfoBlock from "@/components/InfoBlock.vue";
import Counter from "@/components/PlatformSettings/Counter.vue";
import serviceDomain from "@/api/serviceDomain";
import { mapGetters } from "vuex";
import "@/assets/css/_modal.scss";

export default {
  name: "BuyDomain",
  components: {
    InfoBlock,
    Counter,
  },
  data() {
    return {
      currentTab: "manual",
      tabs: ["manual", "auto"],
      domainType: "Landing",
      domainTypeList: ["TDS", "Landing"],
      zones: [],
      currentDomain: null,
      currentAutoBuyDomains: [],
      isDataLoaded: false,
      isLoading: false,
      isActive: false,
      amountDomain: 1,
      interval: { value: 6, label: this.$t("domain.buy_domain_modal.interval.6h") },
    };
  },
  computed: {
    ...mapGetters({
      featureFlags: "user/getFeatureFlags",
    }),
    intervalList() {
      return [
        { value: 6, label: this.$t("domain.buy_domain_modal.interval.6h") },
        { value: 12, label: this.$t("domain.buy_domain_modal.interval.12h") },
        { value: 24, label: this.$t("domain.buy_domain_modal.interval.24h") },
      ];
    },
    isValidAutoBuy() {
      if (!this.amountDomain || !this.interval.value) return false;

      const runsPerDay = 24 / this.interval.value;
      const totalPerDay = this.amountDomain * runsPerDay;

      return totalPerDay <= 10;
    },
    intervalInSeconds() {
      return this.interval?.value * 3600;
    },
    selectedZones() {
      return this.currentAutoBuyDomains.map((el) => el.zone);
    },
    defaultZone() {
      return this.zones.find((el) => el.zone === "today") || this.zones[0];
    },
  },
  methods: {
    buyDomain() {
      this.$emit("buy-domain", this.domainType, this.currentDomain);
    },
    getDomainZones() {
      serviceDomain
        .getDomainZones()
        .then((res) => {
          if (res?.status === 200) {
            this.zones = res.data.domain_zones;

            this.setDefaultDomain();
            this.getAutoBuyDomain();
          }
        })
        .finally(() => {
          this.isDataLoaded = true;
        });
    },
    getAutoBuyDomain() {
      serviceDomain.getAutoBuyDomain().then((res) => {
        if (res && res.status === 200 && res.data.settings) {
          this.setDataDomain(res.data.settings);
        }
      });
    },
    setDataDomain({ interval, quantity, zones, isActive }) {
      if (!isActive) {
        this.resetAutoBuySettings();

        return;
      }

      if (interval) {
        const h = interval / 3600;
        this.interval = this.intervalList.find((el) => el.value === h);
      }

      if (quantity) {
        this.amountDomain = quantity;
      }

      if (this.zones.length && zones?.length) {
        this.currentAutoBuyDomains = this.zones.filter((item) => zones.includes(item.zone));
      }

      this.isActive = isActive;
    },
    setDefaultDomain() {
      this.currentDomain = this.defaultZone;
      this.currentAutoBuyDomains.push(this.defaultZone);
    },
    setAutoBuyDomain(active) {
      if (!this.isValidAutoBuy) {
        return;
      }

      this.isLoading = true;

      const params = {
        quantity: this.amountDomain,
        interval: this.intervalInSeconds,
        zones: this.selectedZones,
        isActive: active,
      };

      serviceDomain
        .setAutoBuyDomain(params)
        .then((res) => {
          if (res && res.status === 200) {
            if (active) {
              this.$emit("refresh");
              this.getAutoBuyDomain();
            } else {
              this.resetAutoBuySettings();
            }

            this.$alert({
              type: active ? "success" : "error",
              title: this.$t(`domain.buy_domain_modal.success_${active ? "launch" : "stop"}`),
            });
          } else {
            this.$alert({
              title: this.$t("sent_error"),
              text: res?.message,
            });
          }
        })
        .finally(() => {
          this.isLoading = false;
        });
    },
    resetAutoBuySettings() {
      this.amountDomain = 1;
      this.interval = this.intervalList.find((el) => el.value === 6);
      this.currentAutoBuyDomains = this.defaultZone ? [this.defaultZone] : [];
      this.isActive = false;
    },
    checkFeatureFlag() {
      if (!this.featureFlags.includes("domain_auto_purchase")) {
        this.tabs = ["manual"];
      }
    },
  },
  mounted() {
    this.checkFeatureFlag();
    this.getDomainZones();
  },
};
</script>
<style lang="scss" scoped>
.domain-modal {
  padding: 35px 40px 40px;

  .domain-title {
    font-size: 30px;
    font-weight: 700;
    line-height: 1.5;
    color: #141414;
    margin-bottom: 20px;

    svg {
      margin-right: 8px;
      margin-bottom: 4px;
    }
  }

  .tabs {
    padding: 10px 10px 0 10px;
    flex-wrap: nowrap;
    margin-bottom: 30px;

    @media screen and (max-width: 768px) {
      flex-direction: column;
    }

    li {
      width: calc(50% - 6px);

      @media screen and (max-width: 768px) {
        width: 100%;
      }
    }
  }

  .btn {
    min-width: 162px;
  }
}

@media screen and (max-width: 980px) {
  .form-item__label {
    margin-top: 15px;
  }
}

.domain-text {
  color: #141414;
  font-size: 28px;
  font-weight: 700;
  line-height: 2.1;

  &.no-domain {
    font-size: 24px;
    line-height: 1.6;
  }
}

.domain-seconrady {
  background: rgba(233, 242, 242, 0.65);
  border-radius: 10px;
  padding: 0 32px;
  text-align: center;
}

.domain-info {
  display: flex;
  align-items: center;
  gap: 0 10px;
  color: #375b5b;
  font-size: 16px;
  line-height: 1.5;

  svg {
    fill: #375b5b;
  }
}

.domain-price,
.green-text {
  color: #37807d;
}

.domain-type {
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-bottom: 20px;

  .green-text {
    font-size: 12px;
    padding-left: 5px;
  }
}

.custom-multiselect-list__block:hover .green-text {
  color: #fff;
}

::v-deep {
  .custom-multiselect-wrapper {
    border: solid 1px transparent;
    transition: 0s border ease;
  }

  .form-item__field {
    margin-bottom: 0;
  }
}

.invalid {
  &::v-deep {
    .custom-multiselect-wrapper {
      border: solid 1px red;
    }
  }
}

.vm--modal.vm--modal {
  overflow: visible !important;
}

.warning-block {
  display: flex;
  font-size: 14px;
  color: #c62424;
  margin-top: 20px;

  svg {
    fill: #c62424;
    margin-right: 10px;
  }
}

.domain-footer {
  display: flex;
  flex-wrap: wrap;
  margin-top: 35px;

  @media screen and (max-width: 768px) {
    flex-direction: column-reverse;
    margin-top: 25px;
  }
}

.autobuy-active {
  position: relative;
  color: #37807d;
  margin-top: 16px;
  margin-left: 15px;
  padding-left: 30px;
  font-size: 14px;

  &:after {
    position: absolute;
    content: "";
    top: 5px;
    left: 12px;
    width: 9px;
    height: 9px;
    border-radius: 50%;
    background-color: #37807d;
  }

  @media screen and (max-width: 768px) {
    margin: 0 0 20px 0;
  }
}

.price-block {
  position: relative;
  background: #f9fbfb;
  border: 1px solid #cad5d5;
  border-radius: 10px;
  padding: 17px 30px 17px 54px;
  font-size: 14px;
  line-height: 20px;
  line-height: 24px;
  color: #375b5b;

  svg {
    position: absolute;
    height: inherit;
    margin: 0;
    top: 18px;
    left: 24px;
  }

  .price {
    background-color: #e2eeee;
    border-radius: 10px;
    font-weight: 600;
    padding: 4px 6px;
    font-size: 16px;
  }
}

.badge-new {
  position: relative;
  color: #000;
  font-weight: 600;
  font-size: 12px;
  padding: 3px 8px;
  background-color: #f1cd4d;
  margin-left: 12px;
  border-radius: 5px;

  &::after {
    position: absolute;
    top: 8px;
    left: -6px;
    content: "";
    width: 0;
    height: 0;
    border: 0 solid transparent;
    border-top-width: 5px;
    border-bottom-width: 5px;
    border-right: 7px solid #f1cd4d;
  }
}
</style>
